// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contentContainer___VpjN6{margin:var(--made-space-4-x) var(--made-space-4-x) var(--made-space-6-x) var(--made-space-4-x)}\n", "",{"version":3,"sources":["webpack://./src/components/SidePanel/SidePanelContent/SidePanelContent.css"],"names":[],"mappings":"AAAA,0BACI,8FACJ","sourcesContent":[".contentContainer {\n    margin: var(--made-space-4-x) var(--made-space-4-x) var(--made-space-6-x) var(--made-space-4-x);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": "contentContainer___VpjN6"
};
export default ___CSS_LOADER_EXPORT___;
